<template>
  <el-form-item :label="i18nt('designer.setting.plain')">
    <el-switch v-model="optionModel.plain"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"

  export default {
    name: "plain-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// plain-editor.vue?271d635c